import type { ReactNode } from 'react';
import { useInterfaceStore } from '../../stores/InterfaceStore';
import { getPageLayout } from '../InterfacePage';
import { useRegistryContext } from '../RegistryProvider';
import { usePrint } from '../../../context/PrintContext';
import { PrintLayout, PrintLayoutSlots } from './PrintLayout';

type Props = {
  children: ReactNode;
};

// Refer to https://medium.com/@Idan_Co/the-ultimate-print-html-template-with-header-footer-568f415f6d2a for more details
export function InterfacePrintLayout({ children }: Props) {
  const isPrinting = usePrint();
  const exportLayout = useInterfaceStore().use.page.exportLayout();
  const { header: exportHeader, footer: exportFooter } = getPageLayout(exportLayout);
  const BlockRenderer = useRegistryContext().registry.getBlockRenderer();

  if (!isPrinting) {
    return children;
  }

  if (!exportHeader && !exportFooter) {
    return children;
  }

  return (
    <PrintLayout>
      <PrintLayout.Slot name={PrintLayoutSlots.Header}>
        {exportHeader ? (
          <BlockRenderer blockId={exportHeader} key={exportHeader} parentBlockId={null} />
        ) : null}
      </PrintLayout.Slot>
      <PrintLayout.Slot name={PrintLayoutSlots.Body}>{children}</PrintLayout.Slot>
      <PrintLayout.Slot name={PrintLayoutSlots.Footer}>
        {exportFooter ? (
          <BlockRenderer blockId={exportFooter} key={exportFooter} parentBlockId={null} />
        ) : null}
      </PrintLayout.Slot>
    </PrintLayout>
  );
}
